import { LucideIcon } from '@lucide/angular';

export interface StackedListConfig {
  items: StackedListItem[];
}

export interface StackedListItem {
  id: string;
  doc_id?: string;
  title: string;
  description: string;
  image: string;
  type: StackedListItemType;
  badges?: StackedListBadgeConfig[];
  actions?: StackedListAction[];
  insurerLogo?: string;
}

export interface StackedListBadgeConfig {
  name: string;
  color: string;
}

export interface StackedListAction {
  icon: LucideIcon;
  classes: string;
  handler: (item: StackedListItem, event: Event) => void;
}

export enum StackedListItemType {
  Path = 'path',
  Callback = 'callback',
}
